import { io } from 'socket.io-client';

// Use same base URL pattern - remove /api suffix for socket connection
const BASE_URL = process.env.REACT_APP_API_URL || 'https://backend-c-0mxm.onrender.com';
const SOCKET_URL = BASE_URL.replace(/\/api$/, '');

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  /**
   * Connect to socket server
   */
  connect() {
    if (this.socket?.connected) {
      return this.socket;
    }

    this.socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000
    });

    this.socket.on('connect', () => {
      console.log('🔌 Socket connected:', this.socket.id);
    });

    this.socket.on('disconnect', (reason) => {
      console.log('🔌 Socket disconnected:', reason);
    });

    this.socket.on('connect_error', (error) => {
      console.error('🔌 Socket connection error:', error);
    });

    return this.socket;
  }

  /**
   * Disconnect from socket server
   */
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.listeners.clear();
    }
  }

  /**
   * Join marketing tasks room
   */
  joinMarketingTasks() {
    if (this.socket) {
      this.socket.emit('join:marketing-tasks');
    }
  }

  /**
   * Leave marketing tasks room
   */
  leaveMarketingTasks() {
    if (this.socket) {
      this.socket.emit('leave:marketing-tasks');
    }
  }

  /**
   * Subscribe to task created event
   */
  onTaskCreated(callback) {
    if (this.socket) {
      this.socket.on('task:created', callback);
      this.listeners.set('task:created', callback);
    }
  }

  /**
   * Subscribe to task updated event
   */
  onTaskUpdated(callback) {
    if (this.socket) {
      this.socket.on('task:updated', callback);
      this.listeners.set('task:updated', callback);
    }
  }

  /**
   * Subscribe to task deleted event
   */
  onTaskDeleted(callback) {
    if (this.socket) {
      this.socket.on('task:deleted', callback);
      this.listeners.set('task:deleted', callback);
    }
  }

  /**
   * Subscribe to task commented event
   */
  onTaskCommented(callback) {
    if (this.socket) {
      this.socket.on('task:commented', callback);
      this.listeners.set('task:commented', callback);
    }
  }

  /**
   * Subscribe to tasks reordered event
   */
  onTasksReordered(callback) {
    if (this.socket) {
      this.socket.on('tasks:reordered', callback);
      this.listeners.set('tasks:reordered', callback);
    }
  }

  /**
   * Remove all task listeners
   */
  removeAllListeners() {
    if (this.socket) {
      this.listeners.forEach((callback, event) => {
        this.socket.off(event, callback);
      });
      this.listeners.clear();
    }
  }

  /**
   * Check if socket is connected
   */
  isConnected() {
    return this.socket?.connected || false;
  }
}

// Create singleton instance
const socketService = new SocketService();

export default socketService;
